import CardQuest from "./CardQuest";
export default CardQuest;